import React from 'react';
import PropTypes from 'prop-types';
import styles from './SeasonPointsBadge.module.css';
import { ReactComponent as CheckmarkIcon } from 'assets/images/icon_checkmark.svg';
import { ReactComponent as XIcon } from 'assets/images/icon_x.svg';

// The badge reads the points setting only. The season-bests setting is deliberately not
// reflected here (Doug, 2026-09-16); the help dialog it opens explains both settings.
const SeasonPointsBadge = ({ countsForSeasonPoints, onClick }) => {
  const awarded = countsForSeasonPoints !== false;
  const className = `${styles.statusBadge} ${awarded ? styles.statusBadgeSuccess : styles.statusBadgeDanger}`;
  const content = (
    <>
      {awarded ? <CheckmarkIcon /> : <XIcon />}
      {awarded ? 'Points' : 'No Points'}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={`${className} ${styles.clickableBadge}`}
        onClick={onClick}
        title="View season points details"
      >
        {content}
      </button>
    );
  }

  return <span className={className}>{content}</span>;
};

SeasonPointsBadge.propTypes = {
  countsForSeasonPoints: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SeasonPointsBadge;
